import InviteFragment from 'garaje/graphql/fragments/employee-schedule/InviteFragment';
import ReservationFragment from 'garaje/graphql/fragments/employee-schedule/ReservationFragment';
import gql from 'graphql-tag';

export default gql`
  mutation ReclaimDeskReservation(
    $deskId: ID!
    $dates: [ISO8601Date!]!
    $locationId: ID!
    $includeEmployeeInvite: Boolean!
  ) {
    reclaimDeskReservation(deskId: $deskId, dates: $dates, locationId: $locationId) {
      invite {
        ...InviteFragment
      }
      reservation {
        ...ReservationFragment
      }
    }
  }
  ${InviteFragment}
  ${ReservationFragment}
`;
